<template>
    <div class="card">
        <div class="card-header">
            <slot name="header"></slot>
        </div>
        <div class="card-body">
            <slot name="body"></slot>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'Card'
};
</script>
  
<style>
.card {
    border-radius: 5px;
    margin: 10px;
    background-color: #1c1c24;
}

.card-header {
    padding: 10px;
    font-size: 16px;
    letter-spacing: 2px;
    color: #fff;
}

.card-body {
    padding: 10px;
    color: #fff;
}
</style>
  